// extracted by mini-css-extract-plugin
export default {"cls1":"dtYjSUbhQFuZL8o4XEDs","cls2":"TmX0MSfTLdPnC2ANnx7N dtYjSUbhQFuZL8o4XEDs"};